__turbopack_context__.v({
  "copy": "LeaderboardFooter-module__iIY87G__copy",
  "footer": "LeaderboardFooter-module__iIY87G__footer",
  "footerCta": "LeaderboardFooter-module__iIY87G__footerCta",
  "title": "LeaderboardFooter-module__iIY87G__title",
});
